import { getOneCmsApiUrl } from '../selectors/selectors';

export default {
  fetch: (contentPath, action, state) => ({
    url: `${getOneCmsApiUrl(state)}/${contentPath}`,
    opts: {
      credentials: 'omit',
    },
  }),
};
